/**
 * Price Variance (construction Phase 2): invoice lines for a period against the
 * contract pricebook rate for the same supplier and resource code.
 * Backend: `/api/v1/barratt/price-variance/`.
 */
import api, { type AxiosResponse } from './client';

export type PriceVarianceStatus = 'over' | 'exact' | 'under';

export interface PriceVarianceRow {
  id: number;
  supplier_id: number;
  supplier_name: string;
  invoice_date: string;
  po_number: string;
  resource_code: string;
  description: string;
  division_name: string;
  commodity_code: string;
  quantity: string;
  unit: string;
  net_amount: string;
  unit_price: string;
  contract_price: string;
  contract_number: string;
  contract_id: number;
  variance: string;
  variance_value: string;
  status: PriceVarianceStatus;
}

export interface PriceVarianceTotals {
  compared_count: number;
  over_count: number;
  exact_count: number;
  under_count: number;
  over_value: string;
  under_value: string;
  compared_value: string;
  uncompared_count: number;
  uncompared_value: string;
  suppliers_over: number;
}

export interface PriceVarianceResponse {
  rows: PriceVarianceRow[];
  totals: PriceVarianceTotals;
  truncated: boolean;
  start: string;
  end: string;
}

export const priceVarianceAPI = {
  get: (params: { start?: string; end?: string; supplier?: number; site?: number; company?: number; group?: number }):
    Promise<AxiosResponse<PriceVarianceResponse>> =>
    api.get('/barratt/price-variance/', { params }),
};
